import React from 'react'

const PermissionChanges = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Permission Changes</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">System Logs</li>
            <li className="breadcrumb-item active">Permission Changes</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Permission Changes</h5>
                <p>View and audit all user permission changes.</p>
                {/* Add permission changes table/component here */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default PermissionChanges

